import React from "react";
import { getOptimizedImageUrl, generateImageSrcSet } from "../../utils/imageOptimization";

interface OptimizedImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  path: string;       // Ruta de la imagen en tu almacenamiento (ej: /clasicas/torta.jpg)
  width?: number;     // Ancho opcional para redimensionado al vuelo
  quality?: number;   // Calidad opcional (por defecto 80)
  useSrcSet?: boolean; // Si debe generar un srcset responsivo (útil para banners/catálogos)
}

/**
 * Componente OptimizedImage
 * 
 * Un envoltorio premium para la etiqueta <img> que automatiza la conexión
 * y optimización de imágenes en tiempo real mediante ImageKit.
 */
const OptimizedImage: React.FC<OptimizedImageProps> = ({
  path,
  alt,
  width,
  quality = 80,
  useSrcSet = false,
  loading = "lazy",
  decoding = "async",
  className = "",
  ...props
}) => {
  // Construye la URL final optimizada usando ImageKit
  const src = getOptimizedImageUrl(path, width, quality);
  
  // Genera el srcSet responsivo si se solicita y no es una URL absoluta externa
  const srcSet = useSrcSet && !path.startsWith("http")
    ? generateImageSrcSet(path)
    : undefined;

  return (
    <img
      src={src}
      alt={alt}
      loading={loading}
      decoding={decoding}
      srcSet={srcSet}
      className={className}
      {...props}
    />
  );
};

export default OptimizedImage;
